const formatter = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' })

export default formatter
